import { useFeedConfig } from '../contexts/feedConfigContext'
import './SurfaceHeading.css'


export function SurfaceHeadingView({ title: titleValue, highlight: highlightValue }: { title?: unknown; highlight?: unknown }) {
  const title = typeof titleValue === 'string' ? titleValue.trim() : ''
  const highlight = typeof highlightValue === 'string' ? highlightValue.trim() : ''

  if (!title) return null

  const highlightIndex = highlight ? title.indexOf(highlight) : -1
  if (highlightIndex < 0) {
    return <h2 className="surface-heading">{title}</h2>
  }

  return (
    <h2 className="surface-heading">
      {title.slice(0, highlightIndex)}
      <span className="surface-heading-highlight">{highlight}</span>
      {title.slice(highlightIndex + highlight.length)}
    </h2>
  )
}

export function SurfaceHeading() {
  const { surface } = useFeedConfig()
  return <SurfaceHeadingView title={surface?.config?.title} highlight={surface?.config?.title_highlight} />
}
